(() => {
  if (window.vvGuideAnalyticsBound) return;
  const source = location.pathname;
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:blogs\/guia-botas-vaqueras\/[^/]+|pages\/(?:cuidado-botas|cuidados|guia-de-tallas[^/]*|western-mexicano))\/?$/i.test(source)) return;
  window.vvGuideAnalyticsBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('#main-content a[href]');
    if (!link || !window.Shopify?.analytics?.publish) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\/[^/]+\/?$/i.test(destination.pathname)) return;
    try {
      Promise.resolve(Shopify.analytics.publish('vv:guide_catalog_click', {
        guide_path: source,
        destination_path: destination.pathname,
        destination_type: destination.pathname.includes('/products/') ? 'product' : 'collection'
      })).catch(() => {});
    } catch (_) { /* Analytics must never interrupt navigation. */ }
  });
})();
